
import {CHANGE_PAGE, LOAD_TOP_WORDS_PAGINATED, SEARCH_CHANGE} from "./full-report-top-words-action-types";
import deepCopy from "../../utilities/deepCopy";
import {afterSearch} from "./functions";

const initialState = {
  page: 1,
  topWordsPaginated: null,
  limboPage: null,
  limboTopWordsPaginated: null,
  searchValue: ""
};


export default ( state = initialState, action ) => {

  const { next, previous, topWordsPaginated, searchValue } = action;

  switch(action.type) {

    case SEARCH_CHANGE:
      if (!searchValue) {
        return {
          ...state,
          page: state.limboPage,
          topWordsPaginated: state.limboTopWordsPaginated,
          searchValue
        }
      }
      const dataToSearch = !state.limboTopWordsPaginated ? state.topWordsPaginated : state.limboTopWordsPaginated;
      const newData = afterSearch(
        {
          data: deepCopy(dataToSearch),
          searchValue
        }
        );
      return {
        ...state,
        topWordsPaginated: newData,
        page: 1,
        limboPage: !state.limboPage ? state.page : state.limboPage,
        limboTopWordsPaginated: !state.limboTopWordsPaginated ? state.topWordsPaginated : state.limboTopWordsPaginated,
        searchValue
      };

    case CHANGE_PAGE:

      const allPages = Object.keys(state.topWordsPaginated).length;
      const newPage = next ? state.page + 1 : state.page - 1;
      if (next) {
        if (newPage > allPages) {
          return state;
        }
        return {
          ...state,
          page: newPage
        }
      }
      if (previous) {
        if (newPage < 1) {
          return state;
        }
        return {
          ...state,
          page: newPage
        }
      }
      return state;

    case LOAD_TOP_WORDS_PAGINATED:
      return {
        ...state,
        topWordsPaginated
      };

    default:
      return state;

  }
}


// WEBPACK FOOTER //
// ./src/modules/full-report-top-words/full-report-top-words-reducer.js